import { ChevronDown, ClipboardList, Sparkles } from "lucide-react";

export const PendingBadge = ({ children, testid }) => (
  <span
    className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap"
    style={{ background: "#FEF3C7", color: "#92400E", border: "1px solid #FDE68A" }}
    data-testid={testid}
  >
    <span className="w-1.5 h-1.5 rounded-full" style={{ background: "#F59E0B" }} />
    {children}
  </span>
);

const THEMES = {
  consulting: {
    section: { background: "linear-gradient(135deg, #0b3d2e 0%, #14523f 55%, #0F6E56 100%)", boxShadow: "0 18px 40px -28px rgba(11,61,46,.6), inset 0 0 0 1px rgba(201,168,76,.3)" },
    chip: { background: "rgba(201,168,76,.16)", color: "#E5C874" },
    accent: "#E5C874",
    summary: "text-emerald-50/75",
    body: "#fafafa",
  },
  thc: {
    section: { background: "linear-gradient(135deg, #0F8A68 0%, #16A37C 55%, #34C08F 100%)", boxShadow: "0 18px 40px -28px rgba(15,138,104,.55), inset 0 0 0 1px rgba(255,255,255,.18)" },
    chip: { background: "rgba(255,255,255,.18)", color: "#FFFFFF" },
    accent: "#D1FAE5",
    summary: "text-white/80",
    body: "#ffffff",
  },
};

export const DashboardBanner = ({ kind, label, title, summary, countLabel, pending = [], total, expanded, onToggle, children }) => {
  const premium = kind === "consulting";
  const t = THEMES[premium ? "consulting" : "thc"];
  return (
    <section
      className="rounded-3xl mb-6 overflow-hidden scroll-mt-24"
      style={t.section}
      data-testid={`dashboard-banner-${kind}`}
      id={premium ? "consultorias" : undefined}
    >
      <div className="flex flex-wrap items-center gap-3 sm:gap-4 px-5 sm:px-7 py-5" data-testid={`dashboard-banner-${kind}-header`}>
        <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0" style={t.chip}>
          {premium ? <Sparkles className="w-5 h-5" /> : <ClipboardList className="w-5 h-5" />}
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-bold uppercase tracking-[0.22em]" style={{ color: t.accent }}>{label}</div>
          <h2 className={`font-display text-lg sm:text-xl font-bold ${premium ? "text-[#F8F5E8]" : "text-white"}`}>{title}</h2>
          {summary && <div className={`text-[13px] mt-0.5 ${t.summary}`} data-testid={`dashboard-banner-${kind}-summary`}>{summary}</div>}
        </div>
        <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
          {pending.map((p) => <PendingBadge key={p} testid={`dashboard-banner-${kind}-pending`}>{p}</PendingBadge>)}
          {countLabel && (
            <span className="rounded-full px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap" style={t.chip} data-testid={`dashboard-banner-${kind}-count`}>
              {countLabel}
            </span>
          )}
        </div>
      </div>
      <div className="px-3 sm:px-5 pb-5 pt-4" style={{ background: t.body }}>
        {children}
        {total > 0 && (
          <button
            onClick={onToggle}
            className="mx-auto mt-2 flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-5 py-2 text-[13px] font-semibold text-[#0F6E56] hover:bg-emerald-50/60 transition-colors"
            data-testid={`dashboard-banner-${kind}-toggle`}
          >
            {expanded ? "Ver menos" : `Ver todos (${total})`}
            <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${expanded ? "rotate-180" : ""}`} />
          </button>
        )}
      </div>
    </section>
  );
};
